import { render } from "./fsm-player-controllers.vue?vue&type=template&id=30a43326"
import script from "./fsm-player-controllers.vue?vue&type=script&lang=ts"
export * from "./fsm-player-controllers.vue?vue&type=script&lang=ts"
script.render = render

export default script